const homeAdmin = {
  mainTitleHomeAdmin: 'Update data on traffic conditions in Ho Chi Minh City',
  PositionChooseAdminMap: 'Select a specific location on the map where you want to update the data',
  subtitleStatus: 'Information about traffic status',
  currentVelocity: 'Current velocity',
  effectiveTime: 'The effective time',
  description: 'Description',
  reason: 'Reason of this status',
  reasonLabel: 'Reason',
  weather: 'Weather condition',
  weatherLabel: 'Weather',
  unitEffectiveTime: 'minutes',
  titleUpdateButton: 'Update traffic status',
  trafficJam: 'Traffic jam',
  flooding: 'Flooding',
  obstacle: 'Obstacle',
  accident: 'Accident',
  police: 'Police',
  forbiddenRoad: 'Forbidden road',
  blankWeather: '--',
  clearSky: 'Clear sky',
  scatteredClouds: 'Scattered clouds',
  brokenClouds: 'Broken clouds',
  lightRain: 'Light rain',
  heavyRain: 'Heavy rain',
  mist: 'Mist',
  ViewTrafficStatusButtonAdmin: 'View traffic status',
  UpdateTrafficStatusButtonAdmin: 'Update traffic status',
  ViewTrafficStatusTutorialAdmin: `With mode "VIEW TRAFFIC STATUS" you can see traffic status on Map but you can't update traffic status.`,
  UpdateTrafficStatusTutorialAdmin: `With mode "UPDATE TRAFFIC STATUS" you can't see traffic status on Map but you can update traffic status.`,
  NotFoundRoadError: `Can't find the way between these two points`,
  SpeechReport: 'Speech Report',
  FormReport: 'Form Report',
  notification:`Notification`,
  close:`Close`,
  healthFacilityName: `Health facility name`,
  address: `Address`,
  workTime: `Work time`,
  specialisation: `Specialisations`,
  service: `Services`,
  phoneNumber: `Phone number`,
  license: `License`,
  accept: `Accept`,
  reject: `Reject`
}

export default homeAdmin;
